import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from "firebase/storage";
import { getAuth } from "firebase/auth";
const firebaseConfig = {
    apiKey: "AIzaSyAj3yBlt6aQ0xpnBBt_CgD05mC5sx6n0d0",
    authDomain: "event-planet-prod.firebaseapp.com",
    projectId: "event-planet-prod",
    storageBucket: "event-planet-prod.appspot.com",
    messagingSenderId: "7671471283",
    appId: "1:7671471283:web:40198e8ab8997fb654e4c6",
    measurementId: "G-J3V34JXYBL"
};
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const init = {
    db,
    storage,
    app,
    auth
}
export default init;